export default {
    methods: {
        sortArrayOfObjects(array, key) {
            array.sort((a, b) => {
                if (a[key] > b[key]) {
                    return 1;
                }
                if (a[key] < b[key]) {
                    return -1;
                }
                return 0;
            });
            return array;
        },
        calcPercentage(capacity, occupation) {
            return (occupation * 100) / capacity;
        },
        async sleep(milliseconds) {
            await new Promise( r => setTimeout(r, milliseconds))    
        }
    }
}